import { render, staticRenderFns } from "./MediaPackageMedia.vue?vue&type=template&id=2a0bf980&"
import script from "./MediaPackageMedia.vue?vue&type=script&lang=js&"
export * from "./MediaPackageMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports